


















































import Vue from "vue";

import { setItem } from "@/utils/Storage";

export default Vue.extend({
  name: "LoginPage",
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {
    validated(): boolean {
      return this.username.length > 0 && this.password.length > 0;
    }
  },
  methods: {
    login(): void {
      setItem("SESSION", "true");
      this.$router.push({ name: "list" });
    }
  }
});
